import React from 'react'

class AppleSignupButton extends React.Component {
  render() {
      return (
          <a href="/apple_signin?s=pocket&t=signup" className="signup-btn-apple">
              <span className="logo"></span>
              <span className="text">{ this.props.text }</span>
          </a>
      );
  }
}

export { AppleSignupButton }
